import GraphObject from './graphObject.js';
import Utils from './utils.js';

/*****************************************************************************/
export const GROUP_TYPE = '___group___';

export const GROUP_COLORS = [
	new BABYLON.Color3(75/255, 192/255, 192/255, 0.5),
	new BABYLON.Color3(255/255, 206/255, 86/255, 0.5),
	new BABYLON.Color3(54/255, 162/255, 235/255, 0.5),
	new BABYLON.Color3(255/255, 99/255, 132/255, 0.5),
	new BABYLON.Color3(153/255, 102/255, 255/255, 0.5),
	new BABYLON.Color3(255/255, 159/255, 64/255, 0.5),
	new BABYLON.Color3(0/255, 99/255, 132/255, 0.5),
	new BABYLON.Color3(54/255, 0/255, 235/255, 0.5),
	new BABYLON.Color3(255/255, 206/255, 0/255, 0.5),
];
let iCurrColor = 0;
/*****************************************************************************/
export default class Group extends GraphObject
{
	constructor(pParent)
	{
		super(pParent);

		this.vecSize = new BABYLON.Vector2(400, 300);

		this.color = GROUP_COLORS[iCurrColor].clone();
		iCurrColor = (iCurrColor + 1)%GROUP_COLORS.length;

		this.name = 'Group';

		this.nodeIds = {};
	}

	doesContainObject(iNodeId)
	{
		return this.nodeIds[iNodeId];
	}

	getContainedItemCenters(mapOut)
	{
		let pParent = this.getParent();
		for(let iNodeId of Object.keys(this.nodeIds))
		{
			let pNode = pParent.getNode(iNodeId);
			mapOut[iNodeId] = pNode.getCenter().clone();

			if(pNode.getContainedItemCenters)
				pNode.getContainedItemCenters(mapOut);
		}
	}

	saveToObject()
	{
		let pRes = super.saveToObject();
		pRes['color'] = { r: this.color.r, g: this.color.g, b: this.color.b };
		pRes['size'] = { x: this.vecSize.x, y: this.vecSize.y };
		pRes['type'] = GROUP_TYPE;

		pRes['nodeIds'] = {...this.nodeIds};

		return pRes;
	}

	static loadFromObject(pObj, pParent)
	{
		let pGroup = pParent.createGroupRaw();

		GraphObject.loadFromObject(pObj, pGroup);

		pGroup.vecSize.x = pObj['size'].x;
		pGroup.vecSize.y = pObj['size'].y;

		pGroup.color.r = pObj['color'].r;
		pGroup.color.g = pObj['color'].g;
		pGroup.color.b = pObj['color'].b;

		pGroup.nodeIds = pObj['nodeIds'];

		return pGroup;
	}

	setSize(fW, fH)
	{
		if(fW < 80)
			fW = 80;
		if(fH < 80)
			fH = 80;
		this.vecSize.x = fW;
		this.vecSize.y = fH;
	}

	getSize()
	{
		return this.vecSize.clone();
	}

	getColor()
	{
		return this.color;
	}

	getColorAsString(fOpacity)
	{
		return Utils.getColorAsString(this.color, fOpacity);
	}

	setColor(fR, fG, fB)
	{
		this.color.r = fR;
		this.color.g = fG;
		this.color.b = fB;
	}

	getType()
	{
		return GROUP_TYPE;
	}

	addNode(pNode)
	{
		pNode.resetCachedGroupId();
		this.nodeIds[pNode.getId()] = true;
	}

	removeNode(iNodeId)
	{
		if(!this.nodeIds[iNodeId])
			return;

		delete this.nodeIds[iNodeId];
		let pSubnet = this.getParent();
		pSubnet.getNode(iNodeId).resetCachedGroupId();
	}

	getNodes()
	{
		return this.nodeIds;
	}
}
/*****************************************************************************/